import { ComponentProps, PropsWithChildren } from "react";
import { listItemIconClasses, ListItemIconVariants } from "./List.style";
import Box from "@/Box";

type SpanProps = ComponentProps<"span">;
export type ListItemIconProps = SpanProps & ListItemIconVariants;

export function ListItemIcon(props: PropsWithChildren<ListItemIconProps>) {
  const { className, children, ...rest } = props;

  return (
    <Box
      render={<span />}
      className={listItemIconClasses({
        class: className,
      })}
      // {...rest}
    >
      {children}
    </Box>
  );
}

export default ListItemIcon;
